// extracted by mini-css-extract-plugin
module.exports = {"root":"FixedTopBanner_root__v71oH","link":"FixedTopBanner_link__GBs2a"};